import { v4 as uuidv4 } from 'uuid';

/**
 * Replace survey section's ids and UUIds immutabily
 *
 * @param {object} survey
 * @return {sections[]} duplicated sections
 */
export default function replaceSurveySectionIds(survey) {
  const { sections } = survey.payload;
  const modifiedSecs = sections.map((secObj) => ({
    ...secObj,
    id: uuidv4(),
    questions: secObj.questions.map((questObj) => ({
      ...questObj,
      id: uuidv4(),
      question: {
        ...questObj.question,
        uuid: uuidv4(),
      },
      options: questObj.options && questObj.options.map((optObj) => ({
        ...optObj,
        uuid: uuidv4(),
      })),
    })),
    contextQuestions: secObj.contextQuestions && secObj.contextQuestions.map((ctxQuestObj) => ({
      ...ctxQuestObj,
      id: uuidv4(),
      question: {
        ...ctxQuestObj.question,
        uuid: uuidv4(),
      },
      options: ctxQuestObj.options && ctxQuestObj.options.map((opts) => ({
        ...opts,
        answer: {
          ...opts.answer,
          uuid: uuidv4(),
        },
        detailQuestion: opts.detailQuestion ? {
          ...opts.detailQuestion,
          uuid: uuidv4(),
        } : undefined,
      })),
    })),
  }));
  return modifiedSecs;
}
